<template>
  <div>
    <div class="coupons-container" v-if="comeFrom">
      <div class="header-subtitle"><span>共{{availableCoupons ? availableCoupons.length : 0}}张可用优惠券</span></div>
      <div class="coupon-content" :style="{'bottom': emkt.leaveSpaceForFullScreen ? '85px' : '50px'}">
        <div v-if="displayAllCoupons.length > 0">
          <div class="select-coupon" v-for="(coupon, index) in displayAllCoupons">
            <div class="coupon" :style="getCouponStyle(coupon)">
              <img v-show="!getCouponEnabled(coupon)" src="static/img/不可用.png" class="coupon-unuse">
              <div class="coupon-detail">
                <div class="detail-content">
                  <span :style="{'font-size': '14px', 'color': getCouponEnabled(coupon) ? '#68533D' : '#979797'}">{{coupon.label}}</span>
                  <span :style="getUnavailableStyle(coupon)">{{coupon.typeName}} {{ getCouponDisabledText(coupon) }}</span>
                  <span :style="getUnavailableStyle(coupon)">有效期至{{coupon.endDT}}</span>
                </div>
                <div class="detail-discount" v-if="coupon.type === emkt.COUPON_TYPE_DISCOUNT"><span :style="getCouponValueStyle(coupon)">{{getCouponDiscount(coupon)}}</span>折</div>
                <div class="detail-discount" v-else-if="![emkt.COUPON_TYPE.prepaySpecialFundCoupon, emkt.COUPON_TYPE_NEW_DISCOUNT].includes(coupon.type)"><span :style="getCouponValueStyle(coupon)">{{coupon.value}}</span>元</div>
              </div>
              <object class="left-circle" :data="getLeftCirclePath(coupon)" type="image/svg+xml"/>
              <object class="right-circle" :data="getRightCirclePath(coupon)" type="image/svg+xml"/>
              <hr class="coupon-split" :style="{'border-color': getCouponEnabled(coupon) ? '#FFFFFF' : '#EFEEF3'}"></hr>
              <div class="coupon-rule">
                <div class="use-rule" @click="toggleShowRule(index)">
                  <span :style="getUnavailableStyle(coupon)" style="margin-right: 10px;">使用规则</span>
                  <i v-if="!couponShowRule[index]" :style="getUnavailableStyle(coupon)" class="icon-font emkt-icon-zhankai"></i>
                  <i v-if="couponShowRule[index]" :style="getUnavailableStyle(coupon)" class="icon-font emkt-icon-shouqi"></i>
                  <span class="alert-text" style="margin-left: 10px; z-index: 10;" v-show="currentExcluded(coupon)">与已选择优惠券互斥</span>
                </div>
                <div :style="getUnavailableStyle(coupon)" style="padding-bottom: 11px;" v-if="couponShowRule[index]">
                  <div v-for="(items, indexs) in coupon.desc">
                  {{ indexs + 1 }}、{{ items }}。
                  </div>
                </div>
              </div>
            </div>
            <label class="label-checkbox item-content">
              <input type="checkbox" v-model="chosenCoupons" :value="coupon" @change="handleSelectionChange(coupon)" :disabled="checkBoxIsDisabled(coupon)" name="couponCheckbox" >
              <div class="item-media group">
                <i class="icon icon-form-checkbox i-style" :style="{'border-color': checkBoxIsDisabled(coupon) ? '#D9D9D9' : '#979797'}"></i>
              </div>
            </label>
          </div>
        </div>
        <div v-else>
          <img src="/static/img/优惠券空.png" style="width: 100%;margin-top: 50px;">
        </div>
      </div>
      <div class="footer">
        <div class="footer-content">
          <span class="deep-text-color">已选择<span class="alert-text">{{chosenCoupons.length}}</span>张优惠券</span>
          <div class="pay-btn research-background-color" @click="confirmCoupon" v-if="availableCoupons.length > 0">确认使用</div>
          <div class="pay-btn" style="background-color: #979797;" v-else>确认使用</div>
        </div>
        <footer-placeholder></footer-placeholder>
      </div>
    </div>
  <div class="coupons-container" v-else>
    <div class="coupon-content" :style="{'bottom': emkt.leaveSpaceForFullScreen ? '85px' : '50px'}">
      <div v-if="myAllCoupons.length > 0">
        <div class="select-coupon" v-for="(coupon, index) in myAllCoupons">
          <div class="coupon-full" :style="getCouponStyle(coupon)">
            <img v-show="!coupon.available" src="static/img/已过期.png" class="coupon-unuse-full">
            <div class="coupon-detail">
              <div class="detail-content">
                <span :style="{'font-size': '14px', 'color': getCouponEnabled(coupon) ? '#68533D' : '#979797'}">{{coupon.label}}</span>
                <span :style="getUnavailableStyle(coupon)">{{coupon.typeName}} {{ getCouponDisabledText(coupon) }}</span>
                <span :style="getUnavailableStyle(coupon)">有效期至{{coupon.endDT}}</span>
              </div>
              <div class="detail-discount" v-if="coupon.type === emkt.COUPON_TYPE_DISCOUNT"><span :style="getCouponValueStyle(coupon)">{{getCouponDiscount(coupon)}}</span>折</div>
              <div class="detail-discount" v-else-if="![emkt.COUPON_TYPE.prepaySpecialFundCoupon, emkt.COUPON_TYPE_NEW_DISCOUNT].includes(coupon.type)"><span :style="getCouponValueStyle(coupon)">{{coupon.value}}</span>元</div>
            </div>
            <object class="left-circle" :data="getLeftCirclePath(coupon)" type="image/svg+xml"/>
            <object class="right-circle" :data="getRightCirclePath(coupon)" type="image/svg+xml"/>
            <hr class="coupon-split" :style="{'border-color': getCouponEnabled(coupon) ? '#FFFFFF' : '#EFEEF3'}"></hr>
            <div style="margin-top: 10px; float: right">
              <span class="small-font-set1"
                    v-if="getCouponEnabled(coupon) && coupon.isPresent === 1"
                    @click="showPresentCouponDialog(coupon)"
                    style="">
            转赠
          </span>
              <span class="small-font-set"
                    @click="jumpTo"
                    v-if="getCouponEnabled(coupon)"
                    style="">
            立即使用
          </span>
            </div>
              <div class="coupon-rule">
                <div class="use-rule" @click="toggleShowRule(index)">
                  <span :style="getUnavailableStyle(coupon)" style="margin-right: 10px;">使用规则</span>
                  <i v-if="!couponShowRule[index]" :style="getUnavailableStyle(coupon)" class="icon-font emkt-icon-zhankai"></i>
                  <i v-if="couponShowRule[index]" :style="getUnavailableStyle(coupon)" class="icon-font emkt-icon-shouqi"></i>
                  <span class="alert-text" style="margin-left: 10px; z-index: 10;" v-show="currentExcluded(coupon)">与已选择优惠券互斥</span>
                </div>
                <div :style="getUnavailableStyle(coupon)" style="padding-bottom: 11px;" v-if="couponShowRule[index]">
                  <div v-for="(items, indexs) in coupon.desc">
                    {{ indexs + 1 }}、{{ items }}。
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
      <div v-else>
        <img src="/static/img/优惠券空.png" style="width: 100%;margin-top: 50px;">
      </div>
    </div>
  </div>
    <div class="background-modal" v-if="showPresentCoupon" @click="close"></div>
    <div class="choose-pay-method" v-show="showPresentCoupon">
      <div class="content-block">
        <div class="block-item">
          <div class="block-item" style="justify-content: center;">
            <span class="deep-text-color">转赠优惠券</span>
          </div>
          <div style="height: 32px; width: 32px" @click="close">
            <img class="icon4" referrerpolicy="no-referrer" src="/static/img/关闭.png"/>
          </div>
        </div>
        <div class="split-line"></div>
        <div v-show="showPresentCoupon">
          <div class="block-item" style="justify-content: flex-start;">
            <div class="deep-text-color" style="width: 20%;">姓名</div>
            <input class="verity-info" v-model.trim="receiverCustomerName" type="text" placeholder="请输入被转赠人的姓名">
          </div>
          <div class="split-line"></div>
          <div class="block-item" style="justify-content: flex-start;">
            <div style="width: 100%;height: 100%;display: flex;align-items: center;">
              <div class="deep-text-color" style="width: 20%;">手机号</div>
              <input class="verity-info" v-model.trim="receiverCustomerMobile" type="text" placeholder="请输入被转赠人的手机号">
            </div>
          </div>
          <div class="remind-info light-text-color"><span class="alert-text">转赠优惠券之前，请先提醒被转赠人注册淘基因账户，否则无法使用转赠功能</span>
          </div>
        </div>
        <div class="block-item" style="justify-content: center;">
          <div class="pay-btn research-background-color" style="width: 100%;" @click="transferCoupon">确定</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import emkt from './../../emkt'
  import wx from 'wx'

  // import $ from 'jquery'
  import { mapState } from 'vuex'
  import FooterPlaceholder from '../components/FooterPlaceholder'
  export default {
    props: {
      myAllCoupons: {
        type: Array,
        default: []
      },
      comeFrom: {
        type: Boolean,
        default: undefined
      }
    },
    components: {FooterPlaceholder},
    data () {
      return {
        // 选择的优惠券，可能为现金券或者为折扣券
        chosenCoupons: [],
        // 客户自己选择的现金券
        selectedCashCoupon: null,
        displayAllCoupons: [],
        couponShowRule: [],
        availableUniqueCoupons: this.$route.query.availableUniqueCoupons,
        useDiscountCouponOnly: this.$route.query.useDiscountCouponOnly,
        defaultSelectedCoupons: this.$route.query.defaultSelectedCoupons,
        fetchAllCouponsFinish: false,
        presentCoupon: null,
        showPresentCoupon: false,
        receiverCustomerName: null,
        receiverCustomerMobile: null
      }
    },
    watch: {
      'availableAndUnAvailableCoupons': {
        handler: 'setInitialDisplayCoupons',
        immediate: true
      }
    },
    methods: {
      jumpTo () {
        wx.miniProgram.switchTab({
          url: '/pages/category/newCategory'
        })
      },
      setInitialDisplayCoupons () {
        if (!this.unAvailableCoupons) return
        const displayCoupons = JSON.parse(JSON.stringify(this.availableAndUnAvailableCoupons))
        // const defaultCheckedCouponGuids = (this.defaultSelectedCoupons && this.defaultSelectedCoupons.map(coupon => coupon.promotionGuid)) || []
        this.chosenCoupons = []
        console.log(this.defaultSelectedCoupons)
        if (this.defaultSelectedCoupons) {
          this.defaultSelectedCoupons.forEach(item => {
            displayCoupons.forEach(coupon => {
              const chosenCouponPromotionGuids = this.chosenCoupons.map(coupon => coupon.promotionGuid)
              if (item.code === item.promotionGuid + 'zhe') {
                if (item.promotionGuid.includes(coupon.promotionGuid)) {
                  if (!chosenCouponPromotionGuids.includes(coupon.promotionGuid)) {
                    this.chosenCoupons.push(coupon)
                  } else {
                    // 重复的未被选择的折扣券用repeat属性来区分
                    coupon.repeat = true
                  }
                }
              } else {
                if (item.promotionGuid.includes(coupon.promotionGuid) && item.code.includes(coupon.code)) {
                  if (!chosenCouponPromotionGuids.includes(coupon.promotionGuid)) {
                    this.chosenCoupons.push(coupon)
                  } else {
                    // 重复的未被选择的折扣券用repeat属性来区分
                    coupon.repeat = true
                  }
                }
              }
            })
          })
        }
        const unchosedCoupons = displayCoupons.filter(coupon => !this.chosenCoupons.includes(coupon))
        this.displayAllCoupons = [...this.chosenCoupons, ...unchosedCoupons]
        this.couponShowRule = this.displayAllCoupons.map(coupon => false)
      },
      checkBoxIsDisabled (coupon) {
        if (this.useDiscountCouponOnly) return true
        if (this.getCouponEnabled(coupon) === false) return true
      },
      toggleShowRule (index) {
        this.$set(this.couponShowRule, index, !this.couponShowRule[index])
      },
      checkChosenCoupons () {
        if (this.useDiscountCouponOnly === false) {
          if (this.chosenCoupons.length > 1) {
            this.$weui.topTips('只能选择一张现金券', 2000)
            // $.toast('只能选择一张现金券')
            return false
          }
        } else {
          if (this.chosenCoupons.length !== this.defaultSelectedCoupons.length) {
            this.$weui.topTips('折扣券不支持选择', 2000)
            // $.toast('折扣券不支持选择')
            return false
          }
        }
        return true
      },
      confirmCoupon () {
        if (!this.checkChosenCoupons()) {
          return
        }
        console.log(this.$route.params, 'params')
        this.$router.replace({name: 'WeappOrderContentConfirmation', query: {chosenCoupons: this.chosenCoupons, comeFrom: this.$route.params.comeFrom}})
      },
      getCouponStyle (coupon) {
        return this.getCouponEnabled(coupon) ? {} : {background: '#fff'}
      },
      getUnavailableStyle (coupon) {
        return this.getCouponEnabled(coupon) ? {color: '#998776'} : {color: '#979797'}
      },
      getCouponValueStyle (coupon) {
        return this.getCouponEnabled(coupon) ? {'font-size': '32px', 'color': '#361B00'} : {'font-size': '32px', 'color': '#979797'}
      },
      getLeftCirclePath (coupon) {
        return this.getCouponEnabled(coupon) ? '/static/img/svg/左半圆.svg' : '/static/img/svg/白左半圆.svg'
      },
      getRightCirclePath (coupon) {
        return this.getCouponEnabled(coupon) ? '/static/img/svg/右半圆.svg' : '/static/img/svg/白右半圆.svg'
      },
      currentExcluded (coupon) {
        // 优惠券互斥
        if (!this.getCouponEnabled(coupon) || this.chosenCoupons.length === 0) {
          return false
        }
        if (this.useDiscountCouponOnly) {
          return !this.chosenCoupons.map(coupon => coupon.code).includes(coupon.code) || coupon.repeat === true
        } else {
          return !this.chosenCoupons.map(coupon => coupon.code).includes(coupon.code)
        }
      },
      handleSelectionChange (coupon) {
        if (coupon.type === emkt.COUPON_TYPE_DISCOUNT) {
          this.$weui.topTips('折扣券不支持重新选择', 2000)
          return
        }
        if (this.getCouponEnabled(coupon) === false) {
          this.$weui.topTips('此优惠券不可用', 2000)
          return
        }
        const couponCodes = this.chosenCoupons.map(coupon => coupon.code)
        this.chosenCoupons = couponCodes.includes(coupon.code) ? [coupon] : []
        console.log('handleSelectionChange coupon selected', coupon, this.chosenCoupons, couponCodes)
      },
      getCouponDiscount (coupon) {
        if (!coupon || !coupon.value) {
          return ''
        }
        let discount = (1 - coupon.value) * 10
        if (!discount) {
          return ''
        }
        let twoDigit = discount.toFixed(2)
        if (twoDigit && twoDigit.toString().endsWith('0')) {
          return discount.toFixed(1)
        } else {
          return discount.toFixed(2)
        }
      },
      showPresentCouponDialog (coupon) {
        console.log('-------------', coupon)
        this.showPresentCoupon = true
        this.presentCoupon = coupon
      },
      transferCoupon () {
        var self = this
        if (!self.presentCoupon) {
          self.$weui.topTips('请选择一张优惠券', 2500)
          return
        }
        if (!self.receiverCustomerName || !self.receiverCustomerMobile) {
          self.$weui.topTips('请输入姓名和手机号', 2500)
          return
        }
        if (self.receiverCustomerName === this.sessionInfo.customerInfo.customerName && self.receiverCustomerMobile === this.sessionInfo.customerInfo.mobile) {
          self.$weui.topTips('您已有该优惠券，不能重复转赠', 2500)
          return
        }
        this.$weui.loading('请稍等....')
        var transferCouponParam = {}
        transferCouponParam.customerNo = this.sessionInfo.customerInfo.customerNo
        transferCouponParam.customerName = this.sessionInfo.customerInfo.customerName
        transferCouponParam.receiveCustomerName = self.receiverCustomerName
        transferCouponParam.receiveCustomerMobile = self.receiverCustomerMobile
        transferCouponParam.promotionGuid = self.presentCoupon.promotionGuid
        transferCouponParam.couponCode = self.presentCoupon.code
        transferCouponParam.value = self.presentCoupon.value
        transferCouponParam.type = self.presentCoupon.type
        console.log('transferCoupon:', transferCouponParam)
        self.gcapi('transferCoupon', transferCouponParam).then((res) => {
          this.$weui.loading('请稍等....').hide()
          if (res.message) {
            this.$weui.topTips(res.message, 3000)
          } else {
            self.myAllCoupons.forEach((item, index) => {
              if (self.presentCoupon.code.includes(item.code)) {
                self.myAllCoupons.splice(index, 1)
              }
            })
            this.$weui.topTips('转赠成功', 3000)
          }
          self.showPresentCoupon = false
          self.presentCoupon = null
          this.receiverCustomerName = null
          this.receiverCustomerMobile = null
        })
      },
      close () {
        this.showPresentCoupon = false
        this.presentCoupon = null
        this.receiverCustomerName = null
        this.receiverCustomerMobile = null
      },
      getCouponDisabledText (coupon) {
        return coupon.enableFlag !== 1 ? '(未启用)' : ''
      },
      getCouponEnabled (coupon) {
        return (coupon.available && coupon.enableFlag === 1) || false
      }
    },
    computed: {
      ...mapState([
        'cartList', 'sessionInfo'
      ]),
      unAvailableCoupons () {
        if (this.comeFrom) {
          console.log(!this.myAllCoupons && !this.availableUniqueCoupons)
          if (!this.myAllCoupons && !this.availableUniqueCoupons) return []
          let availableCouponCodes
          if (this.availableUniqueCoupons) {
            availableCouponCodes = this.availableUniqueCoupons.map(coupon => coupon.promotionGuid)
            const coupons = this.myAllCoupons.filter(coupon => !availableCouponCodes.includes(coupon.promotionGuid))
            coupons.forEach(coupon => {
              coupon.available = false
            })
            return coupons
          } else {
            let coupons = []
            this.myAllCoupons.forEach(item => {
              item.available = false
              coupons.push(item)
            })
            return coupons
          }
        }
      },
      availableCoupons () {
        if (!this.myAllCoupons || !this.availableUniqueCoupons) return []
        const availableCouponCodes = this.availableUniqueCoupons.map(coupon => coupon.promotionGuid)
        const coupons = this.myAllCoupons.filter(coupon => availableCouponCodes.includes(coupon.promotionGuid))
        coupons.forEach(coupon => {
          coupon.available = true
        })
        return coupons
      },
      availableAndUnAvailableCoupons () {
        if (!this.unAvailableCoupons) return []
        return (this.availableCoupons || this.availableCoupons.length > 0) ? [...this.availableCoupons, ...this.unAvailableCoupons] : [...this.unAvailableCoupons]
      }
    }
  }
</script>

<style scoped>
  .coupons-container {
    width: 100%;
    height:100vh;
    background-color: #FAFAFA;
  }

  .header-subtitle {
    position: fixed;
    top:0;
    left:0;
    background-color: #fe654d;
    line-height: 25px;
    font-size: 12px;
    color: #fff;
    width: 100%;
    z-index: 10;
  }
  .header-subtitle span {
    margin-left: 6.67vw;
  }
  .footer-content {
    height: 50px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 9px 10px;
  }
  .coupon-content {
    /*border: 1px solid #000000;*/
    position: fixed;
    top: 25px;
    bottom: 50px;
    overflow-y:scroll;
    overflow-x:hidden;
    /*background-color: #FAFAFA;*/
    width: 100%;
  }
  .alert-text {
    color: #FE654D;
  }
  .select-coupon {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    margin-top: 10px;
  }
  .small-font-set {
    border-radius:30px;
    background: #361B00;
    padding: 3px 10px 3px 10px;
    color: #F8E6C5;
    font-size: 12px;
    margin-top: 5px;
    border: 1.5px solid;
    width: 71px;
  }
  .small-font-set1 {
    border-radius:30px;
    padding: 3px 15px 3px 15px;
    color: #361B00;
    border: 1.5px solid #361B00;
    font-size: 12px;
    margin-top: 5px;
    margin-right: 10px;
    width: 71px;
  }
  .coupon {
    width: 84vw;
    font-size: 12px;
    color: #998776;
    background: #F8E6C5;
    box-shadow: 0 1px 4px 0 rgba(0,0,0,0.05);
    border-radius: 12px;
    padding: 0 12px;
    position: relative;
  }
  .coupon-full {
    width: 95vw;
    padding: 0 12px;
    font-size: 12px;
    color: #998776;
    background: #F8E6C5;
    box-shadow: 0 1px 4px 0 rgba(0,0,0,0.05);
    border-radius: 12px;
    position: relative;
    top: 10px;
  }
  .coupon-unuse {
    width: 49px;
    position: absolute;
    top: -10px;
    right: -7px;
  }
  .coupon-unuse-full {
    width: 49px;
    position: absolute;
    top: 0;
    right: 0;
  }
  .coupon-split {
    margin: 0;
    border: 0;
    border-top: 0.7px dashed #fff;
  }
  .coupon-detail {
    height: 100px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
  .left-circle {
    position: absolute;
    top: 94px;
    left: -10px;
  }
  .right-circle {
    position: absolute;
    top: 94px;
    right: -10px;
  }
  .detail-content {
    width: 60%;
    display: inline-block;
  }
  .detail-content span {
    line-height: 24px;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .detail-discount {
    text-align: right;
    display: inline-block;
  }
  .use-rule {
    line-height: 30px;
    display: flex;
    align-items: center;
    margin-top: 5px;
  }
  .footer {
    position: fixed;
    bottom:0;
    left: 0;
    width: 100%;
    font-size: 14px;
    background-color: #fff;
  }
  .pay-btn {
    width: 110px;
    height: 34px;
    border-radius: 17px;
    line-height: 34px;
    color: #fff;
    text-align: center;
  }
  .customer-service {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  label.label-checkbox input[type=checkbox]:checked+.item-media i.icon-form-checkbox:after {
    background: no-repeat center;
    background-image: url('/static/img/tick.png');
    background-size: .6rem .45rem;
  }

  label.label-checkbox input[type=checkbox]:checked+.item-media i.icon-form-checkbox {
    background-color: #5878fa;
    border: none;
  }
  .background-modal {
    opacity: 0.55;
    background: #000000;
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 10;
  }
  .choose-balance-account, .choose-pay-method {
    position: absolute;
    bottom: 20px;
    left: 0;
    right: 0;
    margin: 0 10px;
    z-index: 20;
    font-size: 14px;
    color: #979797;
  }
  .content-block {
    position: relative;
    margin-top: 0;
    margin-bottom: 10px;
    padding: 0 15px;
    border-radius: 10px;
    width: 100%;
    border: 0.5px solid #EFEEF3;
    background-color: #fff;
  }

  .verity-info {
    text-align: left;
    font-size: 14px;
    color: #979797;
    font-weight: 400;
    width: 80%;
    outline: none;
    border: none;
    padding: 0;
  }
  .block-item {
    height: 62px;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
  }
  .deep-text-color {
    color: #424242;
    font-size: 14px;
    font-weight: bold;
  }
  .split-line {
    border-top: .5px solid #efeef3;
    margin-right: -15px;
    height: 1px;
  }
  .icon4 {
    width: 16px;
    height: 16px;
    margin-top: 8px;
    margin-left: 15px;
  }
</style>



// WEBPACK FOOTER //
// CouponSelection.vue?147ef9d5